import React from 'react';
import styled from 'styled-components';
import Transition from 'components/Transition';
import { Backdrop, ModalWrapper, ModalActions } from '../Modal/modalStyle';
import CopyBlock from 'components/CopyBlock/CopyBlock';
import { useCopy } from 'hooks/useCopy';

/* ── Layout ─────────────────────────────────────────────────────── */

const Panel = styled(ModalWrapper)`
  max-width: 480px;
  width: 90%;
  padding: 2.5rem 3rem;
`;

/* ── Typography ─────────────────────────────────────────────────── */

const Title = styled.h2`
  font-size: 2.4rem;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0 0 1.2rem;
`;

const BodyBlock = styled(CopyBlock)`
  font-size: 1.5rem;
  color: #444;
  line-height: 1.65;

  & > p { margin: 0; }
  & > p + p { margin-top: 0.75rem; }
`;

/* ── CTA ─────────────────────────────────────────────────────────── */

const CTA = styled.button`
  padding: 1rem 2.5rem;
  border-radius: 4px;
  font-size: 1.6rem;
  font-weight: 600;
  cursor: pointer;
  background: #600b68;
  color: #fff;
  border: none;
  width: 100%;
  transition: background 0.2s;

  &:hover { background: #7a1085; }
  &:active { transform: scale(0.98); }
`;

/* ─────────────────────────────────────────────────────────────────── */

interface Props {
  onDismiss: () => void;
}

export default function WelcomeModal({ onDismiss }: Props) {
  const introText = useCopy('modal-intro.txt');

  return (
    <Backdrop>
      <Transition className="fade" enter timeout={500}>
        <Panel onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <Title>Welcome to the Career Ikigai Interview</Title>

          <BodyBlock text={introText} />

          <ModalActions>
            <CTA onClick={onDismiss}>Next</CTA>
          </ModalActions>
        </Panel>
      </Transition>
    </Backdrop>
  );
}
